import { createRoot } from "react-dom/client";
import "modules/hasown-polyfill";
import "modules/array-at-polyfill";
import App from "./App";
import * as Sentry from "@sentry/react";

import "formdata-polyfill";
import "modules/padStart-polyfill";
import "./styles/index.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "modules/patch-arrayBuffer";
import "modules/resizeObserverPolyfill";

window.process = {} as any;

if (!window.Blob) {
  window.Blob = Blob;
}

if (process.env.NODE_ENV === "production" && process.env.REACT_APP_SENTRY_DSN) {
  const sampleRate = parseFloat(process.env.REACT_APP_SENTRY_SAMPLE_RATE || "");
  const tracesSampleRate = parseFloat(
    process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || ""
  );

  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [],
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || "production",
    sampleRate: isFinite(sampleRate) ? sampleRate : 1,
    ignoreErrors: [
      /Document already exists: projects\/ccfolia-160aa\/databases\/\(default\)\/documents\/rooms\//,
      /UnknownError: Connection to Indexed Database server lost./,
      /Failed to start the audio device/,
    ],
    tracesSampleRate: isFinite(tracesSampleRate) ? tracesSampleRate : 1,
  });
} else {
  console.log("DEVELOPMERNT MODE");
}

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(<App />);

const registerServiceWorker = async () => {
  if ("serviceWorker" in navigator) {
    try {
      const registration = await navigator.serviceWorker.register("/fsw.js", {
        scope: "/",
      });
      if (registration.installing) {
        console.log("Service worker installing");
      } else if (registration.waiting) {
        console.log("Service worker installed");
      } else if (registration.active) {
        console.log("Service worker active");
      }
    } catch (error) {
      console.error(`Registration failed with ${error}`);
    }
  }
};

registerServiceWorker();
